import React, { useState } from 'react';
import { TestTube, CheckCircle2, Play, Loader2 } from 'lucide-react';

const E2ETestComposer = ({ project }) => {
  const [composing, setComposing] = useState(false);
  const [tests, setTests] = useState([]);

  const composeTests = () => {
    setComposing(true);
    setTimeout(() => {
      setTests([
        { id: 1, name: 'Full OTC Flow with Credit Check', steps: 12, modules: ['SD', 'FI', 'FSCM'], duration_min: 45 },
        { id: 2, name: 'P2P with GR/IR Clearing', steps: 15, modules: ['MM', 'FI'], duration_min: 38 },
        { id: 3, name: 'Production Order with Backflush', steps: 18, modules: ['PP', 'MM', 'CO'], duration_min: 52 },
        { id: 4, name: 'Intercompany Sales Process', steps: 22, modules: ['SD', 'FI', 'MM'], duration_min: 65 }
      ]);
      setComposing(false);
    }, 2000);
  };

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-xl shadow-md p-6">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-3xl font-bold mb-2">End-to-End Test Composer</h2>
            <p className="text-gray-600">Create cross-module test flows automatically</p>
          </div>
          <button onClick={composeTests} disabled={composing} className="bg-gradient-to-r from-green-600 to-emerald-600 text-white px-6 py-3 rounded-xl flex items-center space-x-2 disabled:opacity-50">
            {composing ? <><Loader2 className="w-5 h-5 animate-spin" /><span>Composing...</span></> : <><Play className="w-5 h-5" /><span>Compose Tests</span></>}
          </button>
        </div>
      </div>

      {tests.length > 0 && (
        <div className="space-y-3">
          {tests.map((test) => (
            <div key={test.id} className="bg-white rounded-xl border-2 border-gray-200 p-5">
              <div className="flex items-start justify-between mb-3">
                <div className="flex-1">
                  <h4 className="font-semibold text-lg text-gray-900 mb-2">{test.name}</h4>
                  <div className="flex items-center space-x-4 text-sm text-gray-600">
                    <span>{test.steps} steps</span>
                    <span>Modules: {test.modules.join(', ')}</span>
                    <span>~{test.duration_min} min</span>
                  </div>
                </div>
                <CheckCircle2 className="w-6 h-6 text-green-600" />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default E2ETestComposer;